/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import {  Outlet, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Box from '@mui/material/Box';

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body');
    return () => {
      document.body.classList.remove('bg-body');
    };
  }, []);

  return (
    <Box
      sx={{
        background: 'linear-gradient(0deg, #083E60 0%, #0C5F93 50%, #083E60 100%)  ',
      }}
      className='  h-full w-full flex flex-col justify-center items-center  min-h-screen '
    >
      <Outlet />
    </Box>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export { AuthPage };
